import { ErrorTypeEnum } from '../../../main/constants/error-type.ts';
import { TrackingEventEnum } from '../../../main/constants/tracking-event.ts';
import { getLocaleUtil } from '../../../main/utils/locale.util.ts';
import { getSentryUtil } from '../../../main/utils/monitoring/sentry.util.ts';
import { getToasterUtil } from '../../../main/utils/toaster.util.ts';
import { getTrackerUtil } from '../../../main/utils/trackers/tracker.util.ts';

import { ANY_ANSWER } from '../../constants/step-answer.ts';
import { checkAnswerMutationRequest } from '../../requests/check-answer.mutation.ts';
import { CheckAnswerInputSchema, CheckAnswerInputType, CheckAnswerResult } from '../../types/learn-validation.types.ts';

export class OpenResponseGraderUtil {
  private static _instance: OpenResponseGraderUtil;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  static get instance(): OpenResponseGraderUtil {
    if (!OpenResponseGraderUtil._instance) {
      OpenResponseGraderUtil._instance = new OpenResponseGraderUtil();
    }
    return OpenResponseGraderUtil._instance;
  }

  async checkAnswer(input: CheckAnswerInputType): Promise<CheckAnswerResult> {
    const parsedInput = CheckAnswerInputSchema.safeParse(input);
    if (!parsedInput.success) {
      this.handleError(input);
      return { isCorrect: false };
    }

    if (input.prototypeAnswer === ANY_ANSWER) {
      return { isCorrect: true };
    }

    const result = await checkAnswerMutationRequest(parsedInput.data);
    if (!result?.success) {
      this.handleError(input, result.message);
      return { isCorrect: false };
    }

    return { isCorrect: result.data.isCorrect };
  }

  private handleError(input: CheckAnswerInputType, message?: string): void {
    const errorMessage = message ?? getLocaleUtil().select('learn:check_answer_failed');
    getToasterUtil().error(errorMessage);
    const error = new Error(errorMessage);
    error.name = ErrorTypeEnum.CHECK_ANSWER_ERROR;

    getSentryUtil().trackError(error, { errorType: ErrorTypeEnum.CHECK_ANSWER_ERROR }, { input });
    getTrackerUtil().track({
      event: TrackingEventEnum.CHECK_ANSWER_FAILED,
    });
  }
}

export const getOpenResponseGraderUtil = (): OpenResponseGraderUtil => OpenResponseGraderUtil.instance;
